<script lang="ts">
import { useUserStore } from '@/stores/userStore.ts'
import { ref } from 'vue'
import 'vue-pdf-embed/dist/styles/annotationLayer.css'
import 'vue-pdf-embed/dist/styles/textLayer.css'
import { useDesignStore } from '../../../stores/designStore.ts'

import BackgroundDecor from '@/components/BackgroundDecor.vue'
import TitleWidget from '@/components/TitleWidget.vue'
import { useManualStore } from '@/stores/manualStore.ts'
import BButton from 'bootstrap-vue-next/src/components/BButton/BButton.vue'
import { close } from 'fs'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import SearchInput from '@/components/SearchInput.vue'
import RuleReferenceDoc from './RuleReferenceDoc.vue'

export default {
  props: ['isCharacter'],
  setup(props, context) {
    const modal = ref(false)
    const userStore = useUserStore()
    const manualStore = useManualStore()
    const { getRules, rulesReference } = storeToRefs(manualStore)
    const designStore = useDesignStore()
    const page = ref('')
    function scrollbarColor() {
      let sec = designStore.secondaryTheme
      let prim = designStore.primaryTheme
      return sec + ' ' + prim
    }

    function getDistance(input: string, key: string) {
      let count = 0
      let inputArr = input.split('')
      let keyArr = input.split('')
      if (input.length < keyArr.length) {
        count += 1
        for (let i = keyArr.length - input.length; i > 0; i--) {
          inputArr.push('*')
        }
      } else {
        inputArr = inputArr.slice(0, keyArr.length)
      }
      let i = 0
      while (i < input.length) {
        if (input[i] != key[i] && input[i] != '*') count++
        i++
      }
      return count
    }
    function getMinTagDistance(input: string, keys: string) {
      let tags = keys.split(':')
      let val = tags.reduce((acc, val) => Math.min(getDistance(input, val), acc), 100)
      return val
    }

    const rulesInPlay = computed(() => {
      let ret = getRules.value
      let sortObj = {}
      if (search.value) {
        ret = ret.filter((rule) => {
          const ruleDist = getDistance(search.value, rule.title.toLowerCase())
          console.log(rule.title, rule.tags)
          const tagDistance = rule.tags
            ? getMinTagDistance(search.value, rule.tags.toLowerCase())
            : 20

          if (ruleDist < 3 || tagDistance < 3) {
            sortObj[rule.title] = ruleDist
            return true
          } else {
            return false
          }
        })
        return ret.sort((a, b) => {
          if (sortObj[a.title] < sortObj[b.title]) {
            return -1
          } else if (sortObj[a.title] > sortObj[b.title]) {
            return 1
          } else {
            return 0
          }
        })
      }
      return ret.sort((a, b) => {
        if (a.title < b.title) {
          return -1
        } else if (b.title < a.title) {
          return 1
        } else {
          return 0
        }
      })
    })
    function getBackground(val) {
      if ((page.value === '' && rulesInPlay.value[0].title === val) || page.value === val) {
        return designStore.alertTheme
      }
      return designStore.primaryTheme
    }

    function closeDropdown() {
      document.getElementById('rules')?.classList.add('tagContainer')
      document.getElementById('rules')?.classList.remove('displayItPlease')
    }
    function openDropdown() {
      document.getElementById('rules')?.classList.remove('tagContainer')

      document.getElementById('rules')?.classList.add('displayItPlease')
    }

    const search = ref('')
    function close() {
      window.setTimeout(closeDropdown, 300)
    }
    function LightenDarkenColor(col, amt) {
      var num = parseInt(col.substring(1), 16)
      var r = (num >> 16) + amt
      var b = ((num >> 8) & 0x00ff) + amt
      var g = (num & 0x0000ff) + amt
      var newColor = g | (b << 8) | (r << 16)
      return '#' + newColor.toString(16)
    }
    const decorScale = computed(() => {
      return window.innerWidth / 650
    })
    return {
      modal,
      userStore,
      props,
      designStore,
      scrollbarColor,
      getRules,
      rulesReference,
      page,
      search,
      rulesInPlay,
      getBackground,
      openDropdown,
      closeDropdown,
      close,
      LightenDarkenColor,
      decorScale
    }
  },
  components: {
    BButton,
    TitleWidget,
    BackgroundDecor,
    SearchInput,
    RuleReferenceDoc
  }
}
</script>

<template>
  <div
    style="height: fit-content"
    :style="{ fontFamily: designStore.font, background: designStore.inputBacking }"
  >
    <title-widget title="Quick Reference"></title-widget>
    <SearchInput
      @focus="openDropdown()"
      @focusout="close()"
      @newValue="(val) => (search = val)"
    ></SearchInput>
    <div style="display: flex; max-height: calc(100vh - 16.5rem)">
      <div id="rules" class="tagContainer" ref="rulesRef" @blur="closeDropdown()">
        <div
          style="
            display: flex;
            flex-direction: column;
            overflow-y: scroll;
            min-width: 14rem;
            width: 15vw;
            height: 100%;
            max-height: calc(100vh - 16.5rem);
          "
          :style="{ scrollbarColor: scrollbarColor(), background: designStore.sidebarBacking }"
        >
          <div v-for="r in rulesInPlay" :key="r.title">
            <b-button
              @click="((page = r.title), closeDropdown())"
              style="width: 98%; margin: 0.25rem; z-index: 6; position: relative"
              :style="{ background: getBackground(r.title), color: designStore.primaryText }"
              >{{ r.title }}</b-button
            >
          </div>
          <div style="align-self: center; margin-top: 1rem" v-if="rulesInPlay.length === 0">
            - No More Entries -
          </div>
        </div>
      </div>
      <div
        style="flex-grow: 1; display: flex; justify-content: center"
        :style="{ background: designStore.pageBackdrop }"
      >
        <div class="largeDecor" :style="{ background: designStore.pageBackdrop }">
          <BackgroundDecor
            :color="LightenDarkenColor(designStore.pageBackdrop, -20)"
            :scale="decorScale"
            :size="decorScale + 'rem'"
            direction="column"
            justify="space-around"
            :icons="[
              'wi-moon-alt-new',
              'wi-moon-alt-waxing-crescent-2',
              'wi-moon-alt-waxing-crescent-3',
              'wi-moon-alt-waxing-crescent-4',
              'wi-moon-alt-waxing-crescent-5',
              'wi-moon-alt-waxing-crescent-6',
              'wi-moon-alt-first-quarter',
              'wi-moon-alt-waxing-gibbous-1',
              'wi-moon-alt-waxing-gibbous-2',
              'wi-moon-alt-waxing-gibbous-3',
              'wi-moon-alt-waxing-gibbous-4',
              'wi-moon-alt-waxing-gibbous-5',
              'wi-moon-alt-waxing-gibbous-6',
              'wi-moon-alt-full'
            ]"
          ></BackgroundDecor>
        </div>
      </div>
      <RuleReferenceDoc
        :page="page || rulesInPlay[0]?.title || 'Sorry! Nothing Found :('"
      ></RuleReferenceDoc>
      <div
        style="flex-grow: 1; display: flex; justify-content: center"
        :style="{ background: designStore.pageBackdrop }"
      >
        <div class="largeDecor" :style="{ background: designStore.pageBackdrop }">
          <BackgroundDecor
            :color="LightenDarkenColor(designStore.pageBackdrop, -20)"
            :scale="decorScale"
            :size="decorScale + 'rem'"
            direction="column"
            justify="space-around"
            :icons="[
              'wi-moon-alt-new',
              'wi-moon-alt-waxing-crescent-2',
              'wi-moon-alt-waxing-crescent-3',
              'wi-moon-alt-waxing-crescent-4',
              'wi-moon-alt-waxing-crescent-5',
              'wi-moon-alt-waxing-crescent-6',
              'wi-moon-alt-first-quarter',
              'wi-moon-alt-waxing-gibbous-1',
              'wi-moon-alt-waxing-gibbous-2',
              'wi-moon-alt-waxing-gibbous-3',
              'wi-moon-alt-waxing-gibbous-4',
              'wi-moon-alt-waxing-gibbous-5',
              'wi-moon-alt-waxing-gibbous-6',
              'wi-moon-alt-full'
            ]"
          ></BackgroundDecor>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.tag {
  width: 12rem;
  margin: 0.25rem;
}
.tagContainer {
  display: block;
}

@media (max-width: 800px) {
  .tagContainer {
    position: absolute;
    z-index: 5;
    display: none;
  }
  .displayItPlease {
    display: block;
    position: absolute;
    z-index: 5;
  }
}
.largeDecor {
  display: none;
}
@media (min-width: 2000px) {
  .largeDecor {
    display: block;
  }
}
</style>
